/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-shadow */
import { useCallback, useState } from 'react';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { v4 as uuidv4 } from 'uuid';
import { GET_SONG, GET_SONG_AS_GUEST } from '../../graphql/queries/song/song';
import useStores from '../../player/hooks/useStores';
import {
  appendTokenToSongAssets,
  dismissErrorMessage,
  displayErrorMessage,
  getSongAudioSrcs,
} from '../../utils/helpers';
import {
  currentSongTypeId,
  isMobileFullscreen,
  isPlayerFullscreen,
  mediaPlayerSelectedSongState,
  playerActive,
  selectedSongId,
  user,
  userLicences,
} from '../../utils/reactiveVars';
import useMediaQuery from '../Others/useMediaQuery';
import useWrapLines from './useWrapLines';
import { showModal } from '../../styles/js/modals';

const useGetSongForPlayer = ({
  guest = false,
  esongbookId = null,
  organisation_ref = null,
  licences = [],
}) => {
  const wrapLines = useWrapLines();
  const { mediaPlayerStore } = useStores();
  const [data, setData] = useState(null);
  const [shareId, setShareId] = useState(null);
  const [ootaShareUUID, setOotaShareUUID] = useState(null);
  const isMobile = useMediaQuery(
    '(max-width: 767px), screen and (min-width: 428px) and (max-width: 926px) and (orientation: landscape) '
  );

  const query = guest ? GET_SONG_AS_GUEST : GET_SONG;
  const resKey = guest ? 'songAsGuest' : 'song';

  const [getSong, { loading, error, refetch }] = useLazyQuery(query, {
    onCompleted: (res) => {
      dismissErrorMessage();
      // eslint-disable-next-line no-shadow
      const data = { song: res[resKey] };

      setData({ song: res[resKey] });
      mediaPlayerSelectedSongState({ loading, data, error });
      if (res[resKey] === null) return;

      let songCopy = { ...data.song };

      if (songCopy.requirePerformanceLicence) {
        // Check user's licences if the played song requires a performance licence
        const hasLicence = licences
          .filter((licence) => licence.song !== null)
          .some(({ song }) => song.id === songCopy.id);

        if (!hasLicence) {
          showModal('performanceLicenceModal');
        }
      }

      songCopy = appendTokenToSongAssets(songCopy, ootaShareUUID);

      // sort audios cos sometimes they do not come in the correct order
      const sortedAudios = [...songCopy.audios]?.sort(
        (a, b) => b.isDefault - a.isDefault
      );
      songCopy.audios = sortedAudios;

      const audioSrs = getSongAudioSrcs(sortedAudios);

      // const modifiedPages = wrapLines(songCopy.pages, songCopy.styleBodySize);
      const modifiedPages = songCopy.pages;

      mediaPlayerStore.song = {
        ...songCopy,
        src: audioSrs,
        pages: modifiedPages,
      };
      mediaPlayerStore.setSong(audioSrs[0]);
      mediaPlayerStore.setReady(true);
      currentSongTypeId(0);
      mediaPlayerStore.setLastPlayheadPositionMs(0);
      mediaPlayerStore.setCurrentPlayheadPositionMs(0);
      mediaPlayerStore.setPlayerHit({
        sessionUUID: uuidv4(),
        audioId: sortedAudios[0].id,
        songId: songCopy.id,
        shareId,
        updateExpected: true,
        updateSequence: 0,
        esongbookId,
      });

      if (guest) {
        // Set shareId before activating player to ensure it's available
        // when MediaPlayer's onError handler checks for guest sessions
        mediaPlayerStore.setShareId(shareId);
        playerActive(true);
        setTimeout(() => {
          mediaPlayerStore.setShowSlide(true);
        }, 3000);
        isPlayerFullscreen(true);
        if (isMobile && isPlayerFullscreen()) {
          isMobileFullscreen(true);
        }
      }
    },
    onError: (err) => {
      mediaPlayerStore.setSong(null);
      mediaPlayerStore.setReady(false);
      mediaPlayerStore.setError(true);

      const errorMessage =
        err?.message === 'This action is unauthorized.'
          ? 'Access denied!'
          : 'Something went wrong';

      displayErrorMessage(errorMessage);
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  });

  const getSongRequest = useCallback(
    (id, songShareId = null, shareUUID = null) => {
      mediaPlayerStore.setReady(false);
      mediaPlayerStore.setShowOSW(false);

      if (guest) {
        setOotaShareUUID(shareUUID);
      }
      getSong({
        variables: {
          id,
          ...(!guest && {
            organisation_ref,
          }),
        },
        ...(guest && {
          context: {
            headers: {
              ootaShareUUID: shareUUID,
            },
          },
        }),
      });
      // storing id in global state cos of some apollo bugs
      selectedSongId(id);
      setShareId(songShareId);
      return id;
    },
    []
  );

  loading && mediaPlayerStore.setReady(false);

  return { getSongRequest, data, refetch };
};

export default useGetSongForPlayer;
